import React from "react";
import "./AlocityLoading.css";
import { useTheme } from "@material-ui/core/styles";

interface Props {
  position?: string;
}

const AlocityLoading = ({ position }: Props) => {
  const theme = useTheme();
  return (
    <div className={position === "absolute" ? "center" : ""}>
      <svg
        width="100"
        height="100"
        viewBox="0 0 168 146"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="alocity-icon-loading" clipPath="url(#clip0_101_2)">
          <g id="original">
            <g id="Group-4-Copy" transform="translate(34.200000, 0.000000)">
              <polygon
                id="Path"
                points="26.79 49.57 0 0 26.79 0 44.9 33.49 54.24 33.49 72.34 0 99.14 0 72.34 49.57"
                fill="#5386CC"
              ></polygon>
            </g>
            <g id="Group-4-Copy-2" transform="translate(0.000000, 58.320000)">
              <polygon
                id="Path-2"
                points="79.11 39.45 49.58 87.44 36.18 64.23 56.13 31.8 51.46 23.71 13.4 24.78 1.42108547e-14 1.58 56.33 0"
                fill="#5386CC"
              ></polygon>
            </g>
            <g id="Group-4-Copy-3" transform="translate(88.430000, 58.320000)">
              <polygon
                id="Path-3"
                points="22.77 0 79.1 1.58 65.7 24.78 27.64 23.71 22.97 31.8 42.93 64.23 29.53 87.44 0 39.45"
                fill="#5386CC"
              ></polygon>
            </g>
          </g>
          <g id="step3" transform="translate(34.200000, 0.000000)">
            <polygon
              id="Path"
              points="26.79 49.57 0 0 26.79 0 44.9 33.49 54.24 33.49 72.34 0 99.14 0 72.34 49.57"
              fill="#5386CC"
            ></polygon>
          </g>
          <g id="step2" transform="translate(0.000000, 58.320000)">
            <polygon
              id="Path-2"
              points="79.11 39.45 49.58 87.44 36.18 64.23 56.13 31.8 51.46 23.71 13.4 24.78 1.42108547e-14 1.58 56.33 0"
              fill="#5386CC"
            ></polygon>
          </g>
          <g id="step1" transform="translate(88.430000, 58.320000)">
            <polygon
              id="Path-3"
              points="22.77 0 79.1 1.58 65.7 24.78 27.64 23.71 22.97 31.8 42.93 64.23 29.53 87.44 0 39.45"
              fill="#5386CC"
            ></polygon>
          </g>
        </g>
        <defs>
          <clipPath id="clip0_101_2">
            <rect width="442" height="315" fill="white"></rect>
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};
export default AlocityLoading;
